<template>
  <div id="quit">
    <img src="../assets/images/logo.png" alt="Heldengame" @click="this.reset" />
    <h1>Dat was het dan!<br />Tot de volgende keer!</h1>
    <div class="wrapper">
      <v-button @click="$router.replace('/contract')">
        Afsluiten met heldencontract
      </v-button>
      <v-button @click="onQuit">
        Afsluiten zonder heldencontract
      </v-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Button from '@/components/Button.vue'

export default {
  name: 'Quit',
  components: {
    'v-button': Button
  },
  computed: {
    ...mapState([
      'isMuted'
    ])
  },
  methods: {
    ...mapActions([
      'reset'
    ]),
    onQuit () {
      this.reset()
      this.$router.replace('/')
    }
  },
  mounted () {
    const source = new Audio('audio/voice/klaar.mp3')
    source.muted = this.isMuted
    source.play().catch(err => {/* ignore */}) // eslint-disable-line
  }
}
</script>

<style scoped lang="scss">
#quit {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  background: url('~@/assets/images/bye.jpg') no-repeat;
  background-position: 65% center;
  background-size: cover;

  img {
    width: 40%;
    margin-bottom: 4.5rem;
  }

  h1 {
    flex: 1;
    margin: 0;
    margin-left: 8%;
    font-size: 4.8rem;
    font-weight: 800;
    letter-spacing: 0.08rem;
  }
}

.wrapper {
  width: 48rem;
  margin-left: 8%;
  margin-bottom: 4.5rem;

  button {
    width: 100%;
    padding: 0;
    margin-bottom: 1.5rem;
  }
}
</style>
